import { __decorate } from "tslib";
import { __metadata } from "tslib";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try {
            step(generator.next(value));
        }
        catch (e) {
            reject(e);
        } }
        function rejected(value) { try {
            step(generator["throw"](value));
        }
        catch (e) {
            reject(e);
        } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function () { if (t[0] & 1)
            throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function () { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f)
            throw new TypeError("Generator is already executing.");
        while (_)
            try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
                    return t;
                if (y = 0, t)
                    op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return { value: op[1], done: false };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [0];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2])
                            _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            }
            catch (e) {
                op = [6, e];
                y = 0;
            }
            finally {
                f = t = 0;
            }
        if (op[0] & 5)
            throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Tariff } from '../../schema';
import { Cache } from '../../core';
import { EShopService } from '../eshop';
var TariffService = /*@__PURE__*/ (function () {
    function TariffService() {
    }
    TariffService.findAllGroups = function () {
        return __awaiter(this, void 0, void 0, function () {
            var eshop;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, EShopService.findAll()];
                    case 1:
                        eshop = _a.sent();
                        return [2 /*return*/, eshop.tariffs];
                }
            });
        });
    };
    TariffService.findAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var groups, tariffs, _i, groups_1, group, _a, _b, tariff;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, TariffService.findAllGroups()];
                    case 1:
                        groups = _c.sent();
                        tariffs = [];
                        for (_i = 0, groups_1 = groups; _i < groups_1.length; _i++) {
                            group = groups_1[_i];
                            for (_a = 0, _b = group.tariffs; _a < _b.length; _a++) {
                                tariff = _b[_a];
                                tariffs.push(tariff);
                            }
                        }
                        return [2 /*return*/, tariffs];
                }
            });
        });
    };
    TariffService.findOneById = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var tariffs, match, _i, tariffs_1, tariff_1, tariff;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, TariffService.findAll()];
                    case 1:
                        tariffs = _a.sent();
                        for (_i = 0, tariffs_1 = tariffs; _i < tariffs_1.length; _i++) {
                            tariff_1 = tariffs_1[_i];
                            if (tariff_1.id === id) {
                                match = tariff_1;
                            }
                        }
                        if (!match) {
                            return [2 /*return*/];
                            //throw new Error(`Tariff id ${id} is not existent.`);
                        }
                        tariff = new Tariff();
                        tariff.loadJSON(match);
                        return [2 /*return*/, tariff];
                }
            });
        });
    };
    TariffService.findOneStandard = function () {
        return __awaiter(this, void 0, void 0, function () {
            var tariffs, subscriptionTypes, match, _i, tariffs_2, tariff;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, TariffService.findAll()];
                    case 1:
                        tariffs = _a.sent();
                        subscriptionTypes = window.subscriptionTypes;
                        for (_i = 0, tariffs_2 = tariffs; _i < tariffs_2.length; _i++) {
                            tariff = tariffs_2[_i];
                            if (tariff.standard && subscriptionTypes.includes(tariff.subscriptionType)) {
                                match = tariff;
                            }
                        }
                        if (!match) {
                            throw new Error("No standard tariff is existent.");
                            return [2 /*return*/];
                        }
                        return [2 /*return*/, new Tariff(match)];
                }
            });
        });
    };
    __decorate([
        Cache(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Number]),
        __metadata("design:returntype", Promise)
    ], TariffService, "findOneById", null);
    __decorate([
        Cache(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], TariffService, "findOneStandard", null);
    return TariffService;
}());
export { TariffService };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/services/tariff/tariff.ts
// module id = null
// module chunks = 